import { DatePicker } from 'antd';
import { ArgsTypeWithCustomKeys } from './calculatorsTypes';

export const MILISECONDS_IN_DAY = 24 * 60 * 60 * 1000;

export const CalculatorDate: React.FC<{
    arg: ArgsTypeWithCustomKeys;
    onInputChange: (
        name: string,
        value: string | undefined,
        type?: 'unitSwitchers' | 'valueSelects',
    ) => void;
}> = ({ arg, onInputChange }) => {
    return (
        <DatePicker
            picker={'date'}
            onChange={(t) => {
                t &&
                    onInputChange(
                        arg?.name,
                        Math.floor(
                            new Date(t?.format('YYYY-MM-DD')).getTime() / MILISECONDS_IN_DAY,
                        ).toString(),
                    );
            }}
            allowClear={false}
            format="DD MMM'YY"
        />
    );
};
